import { frontendURL } from '../../../helper/URLHelper';
import CrmDashboard from './pages/CrmDashboard.vue';
import CrmOverview from './pages/CrmOverview.vue';

const commonMeta = {
  featureFlag: 'crm_sales_pipeline',
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm'),
    name: 'crm_dashboard_index',
    component: CrmDashboard,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/crm/overview'),
    name: 'crm_overview',
    component: CrmOverview,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/crm/pipelines/:pipelineId'),
    name: 'crm_pipeline_view',
    component: CrmDashboard,
    meta: commonMeta,
  },
];
